<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.78271 4H14.6716L18.308 7.63636V20H5.78271V4ZM8.85357 12.7273H16.1263V14.1818H8.85357V12.7273ZM13.9445 15.6364H8.85357V17.0909H13.9445V15.6364Z"
    fill="white"
  />
</svg>
